module.exports = __webpack_public_path__ + "static/media/galeryVinyl6.28d55bb8.jpg";